<template>
  <hr class="horizontal" style="margin: 8px 0" />
  <ServerPickerMini />
  <hr class="horizontal" style="margin: 8px 0" />
  <ExtraOptionPicker
    :disable-uncheck="false"
    :keys="['self_play', 'account_sharing', 'remote_control']"
    :title="$t('path_of_exile.boost_method')"
    :disable-ids="disabledIds"
  />
  <hr class="horizontal" style="margin: 8px 0" />
  <div class="d-flex-column justify-start align-start gap-18">
    <label class="t-white font-family-1 regular-l f-w-600">
      {{ $t("dashboard.extra_options") }}
    </label>

    <ExtraGold />
    <PriorityPicker />

    <AddOnOptions :keys="['stream', 'pvp_title']" />
  </div>
  <hr class="horizontal" style="margin: 8px 0" />
</template>

<script setup>
import ServerPickerMini from "../pickers/ServerPickerMini.vue";
import ExtraOptionPicker from "../cart-pickers/ExtraOptionPicker.vue";
import AddOnOptions from "../cart-pickers/AddOnOptions.vue";
import ExtraGold from "../cart-pickers/ExtraGold.vue";
import PriorityPicker from "../cart-pickers/PriorityPicker.vue";

const checkoutStore = useCheckoutStore();
const { getGamePack, getGame } = useGameStore();
const disabledIds = computed(() => {
  if (checkoutStore.getDetails?.desiredRating > 1800) {
    let options = [];
    const remoteControlOption = getGamePack?.pack_options?.find(
      (option) => option.const_title === "remote_control"
    );
    if (remoteControlOption) {
      options.push(remoteControlOption.id);
    }
    return options;
  }

  return [];
});
</script>
